// @flow
import { get, find } from "lodash";
import wro from "@tvg/api/wro";
import type { RequestOptions, WroResponse } from "@tvg/api/wro/types";
import { type RaceBet } from "@tvg/atomic-ui/_organism/RaceBets/index";
import type { RaceWagerType, RaceProgram } from "@tvg/types/Race";
import Poller from "@tvg/poller";

const poller: Poller = new Poller();
export const raceBetsPollerInterval: number = 10000; // 10 seconds

const formatWroBets = (
  response: { data: WroResponse },
  currentRace: RaceProgram
): RaceBet[] =>
  response.data.wagers
    .filter((wager) => get(wager, "betStatus.code") !== "C")
    .map((wager) => {
      const wagerTypes = get(currentRace, "wagerTypes") || [];
      const raceWagerType = find(
        wagerTypes,
        (wagerType: RaceWagerType) =>
          wagerType.type.code === wager.wagerType.code
      ) || {
        isKey: false,
        legCount: 1,
        type: { ...wager.wagerType }
      };

      return {
        id: wager.serialNumber,
        raceTypeCode: wager.raceTypeAbbreviation,
        betTotal: wager.betTotal,
        wagerAmount: wager.wagerAmount,
        wagerType: raceWagerType.type,
        isKey: raceWagerType.isKey,
        isLeg: raceWagerType.legCount > 1,
        selections: wager.selections.selection.map((selection) =>
          selection.runners.map((runner) => runner.number.toString())
        ),
        isCancelled: wager.betStatus.code === "C",
        isLost: wager.betStatus.code === "L",
        isRefunded: wager.betStatus.code === "R",
        totalWinAmount:
          wager.betStatus.code === "W" ? wager.winningsAmount : undefined
      };
    });

const getRaceBets = (
  options: RequestOptions,
  currentRace: RaceProgram,
  accountNumber: string
) =>
  wro
    .getMyBets(options, accountNumber)
    .then((res) => {
      if (res.status === 200) {
        return formatWroBets(res, currentRace);
      }
      return [];
    })
    .catch(() => []);

const startPoller = (execution: Function): void =>
  poller.start(() => execution(), raceBetsPollerInterval);

const stopPoller = () => poller.stop();

const isPollerRunning = () => poller.isRunning();

export default {
  getRaceBets,
  startPoller,
  stopPoller,
  isPollerRunning
};
